// src/pages/Onboarding.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { OnboardingForm } from "@/components/Onboarding/OnboardingForm";
import { AuthLogo } from "@/components/Auth/AuthLogo";
import { useTranslation } from "@/context/LanguageContext";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Onboarding() {
  usePageMeta("Onboarding — Shattara AI", "", { noIndex: true });
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate("/auth/signin");
        return;
      }

      const { data: profile, error } = await supabase
        .from("profiles")
        .select("onboarding_completed")
        .eq("id", session.user.id)
        .maybeSingle();

      if (!error && profile?.onboarding_completed) {
        navigate("/dashboard");
      }
    };

    checkSession();
  }, [navigate]);

  return (
    <main className="flex-grow px-6 flex flex-col items-center justify-center min-h-screen bg-background animate-in fade-in duration-500">
      <div className="w-full max-w-md space-y-6 animate-in slide-in-from-bottom-4 duration-700">
        <div className="flex justify-center">
          <AuthLogo />
        </div>

        <section className="flex flex-col items-center justify-center gap-2 text-center">
          <h1 className="text-2xl font-semibold">{t("onboarding.completeProfile")}</h1>
          <p className="text-muted-foreground text-center">
            {t("onboarding.finishProfile")}
          </p>

          <div className="mt-4 w-full">
            <OnboardingForm />
          </div>
        </section>
      </div>
    </main>
  );
}
